export default __webpack_public_path__ + "static/media/critical_thinking_inactive.9df02170.svg";